import { IChainType } from '../../../state/type';
import { IWeb3ChainType, IWeb3NetworkType } from '../type';

const networkType: IWeb3NetworkType = 'main';

const chainInfo: IWeb3ChainType & { id: number } = {
  chain: {
    id: 784 as any,
    name: 'SUI' as any,
    nativeCurrency: { decimals: 9, name: 'SUI' as any, symbol: 'SUI' as any }
  } as IChainType,
  id: 784,
  type: 'SUI',
  name: 'SUI',
  icon: undefined,
  networkType
}

export default chainInfo
